import { loadablePage } from 'src/utils/loadable';

export default loadablePage(
  () =>
    import(
      /* webpackChunkName: "ServiceCostModal" */ /* webpackPrefetch: true */
      './InvoiceDateModal.component'
    ),
);
